export const computePriceWithMargin = (cost: number, marginRatio: number): number => {
  return cost * (1 + marginRatio / 100);
};
